import React from 'react'
import { NotificationContainer } from 'react-notifications'

import routes from './routes'

/**
 * Root component, containing routes
 */

const Root = (props) => {
  return (
    <div>
      { routes }
      <NotificationContainer />
    </div>
  )
}

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root/index.js